/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LatestPressReleasesResponseAllOf,
    LatestPressReleasesResponseAllOfFromJSON,
    LatestPressReleasesResponseAllOfFromJSONTyped,
    LatestPressReleasesResponseAllOfToJSON,
} from './LatestPressReleasesResponseAllOf';
import {
    LatestPressReleasesResponseAllOfData,
    LatestPressReleasesResponseAllOfDataFromJSON,
    LatestPressReleasesResponseAllOfDataFromJSONTyped,
    LatestPressReleasesResponseAllOfDataToJSON,
} from './LatestPressReleasesResponseAllOfData';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 最新プレスリリース一覧を取得したときのレスポンス
 * @export
 * @interface LatestPressReleasesResponse
 */
export interface LatestPressReleasesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof LatestPressReleasesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof LatestPressReleasesResponse
     */
    message: string;
    /**
     * 
     * @type {LatestPressReleasesResponseAllOfData}
     * @memberof LatestPressReleasesResponse
     */
    data: LatestPressReleasesResponseAllOfData;
}

export function LatestPressReleasesResponseFromJSON(json: any): LatestPressReleasesResponse {
    return LatestPressReleasesResponseFromJSONTyped(json, false);
}

export function LatestPressReleasesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatestPressReleasesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': LatestPressReleasesResponseAllOfDataFromJSON(json['data']),
    };
}

export function LatestPressReleasesResponseToJSON(value?: LatestPressReleasesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': LatestPressReleasesResponseAllOfDataToJSON(value.data),
    };
}

